import { render, staticRenderFns } from "./HistoricalTrend.vue?vue&type=template&id=1784da00&scoped=true&"
import script from "./HistoricalTrend.vue?vue&type=script&lang=js&"
export * from "./HistoricalTrend.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalTrend.vue?vue&type=style&index=0&id=1784da00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1784da00",
  null
  
)

export default component.exports